export default {
  // Common
  common: {
    welcome: 'Benvenuto',
    logout: 'Disconnetti',
    users: 'Utenti',
    order: 'Ordine',
    orders: 'Ordini',
    orderCount: '{{count}} ordine/i',
    comingSoon: 'Questa pagina sarà un giorno disponibile',
    shipments: 'Spedizioni',
    fleet: 'Flotta',
    languageUpdateError: 'Errore durante l\'aggiornamento della lingua',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    search: 'Cerca',
    filter: 'Filtra',
    reset: 'Ripristina',
    resetFilters: 'Ripristina filtri',
    back: 'Indietro',
    next: 'Avanti',
    contents: 'Indice',
    previous: 'Precedente',
    submit: 'Invia',
    confirm: 'Conferma',
    close: 'Chiudi',
    loading: 'Caricamento in corso...',
    error: 'Errore',
    success: 'Successo',
    yes: 'Sì',
    no: 'No',
    optional: 'Opzionale',
    required: 'Obbligatorio',
    dashboard: 'Dashboard',
    settings: 'Impostazioni',
    view: 'Visualizza',
    download: 'Scarica',
    actions: 'Azioni',
    details: 'Dettagli',
    noData: 'Nessun dato disponibile',
    weight: 'Peso',
    weightUnit: 'kg',
    pallets: 'Pallet',
    price: 'Prezzo',
    priceUnit: '€',
    contact: 'Contatto',
    phone: 'Telefono',
    email: 'Email',
    address: 'Indirizzo',
    publish: 'Pubblica',
    follow: 'Segui',
    accept: 'Accetta',
    decline: 'Rifiuta',
    accepting: 'Accettazione in corso...',
    declining: 'Rifiuto in corso...',
    confirming: 'Conferma in corso...',
    all: 'Tutti',
    active: 'Attivi',
    pending: 'In attesa',
    completed: 'Completati',
    pickup: 'Ritiro',
    delivery: 'Consegna',
    route: 'Itinerario',
    date: 'Data',
    time: 'Ora',
    status: 'Stato',
    cargo: 'Merce',
    trailer: 'Rimorchio',
    driver: 'Autista',
    vehicle: 'Veicolo',
    company: 'Azienda',
    name: 'Nome',
    firstName: 'Nome',
    lastName: 'Cognome',
    description: 'Descrizione',
    instructions: 'Istruzioni',
    notes: 'Note',
    message: 'Messaggio',
    amount: 'Importo',
    shipper: 'Mittente',
    transporter: 'Trasportatore',
    admin: 'Amministratore',
  },

  // Auth
  auth: {
    welcomeTitle: 'Benvenuto su Velox',
    login: {
      title: 'Accesso',
      subtitle: 'Accedi o crea un account per entrare nella tua piattaforma TMS',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Password dimenticata?',
      submit: 'Accedi',
      loading: 'Accesso in corso...',
      success: 'Accesso effettuato con successo!',
      error: 'Credenziali errate',
      fillAllFields: 'Compila tutti i campi',
    },
    signup: {
      title: 'Registrati',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Conferma password',
      firstName: 'Nome',
      lastName: 'Cognome',
      phone: 'Telefono',
      companyName: 'Nome azienda',
      companyType: 'Tipo',
      shipper: 'Speditore',
      transporter: 'Vettore',
      registrationNumber: 'ID Fiscale',
      registrationNumberPlaceholder: 'Es: P.IVA, Codice fiscale...',
      registrationNumberVerifying: 'Verifica in corso...',
      registrationNumberValid: '✓ Numero valido',
      registrationNumberInvalid: '✗ Numero non valido',
      registrationNumberExists: '⚠️ Questa azienda è già registrata',
      countryCode: 'Paese',
      countryCodePlaceholder: 'FR',
      verified: 'Verificato',
      alreadyExists: 'Già registrato',
      verifying: 'Verifica...',
      iban: 'IBAN',
      ibanPlaceholder: 'IT60 X054 2811 1010 0000 0123 456',
      ibanRequired: 'L\'IBAN è obbligatorio',
      foundedDate: 'Data di fondazione dell\'azienda',
      foundedDateRequired: 'La data di fondazione dell\'azienda è obbligatoria',
      acceptTerms: 'Accetto i Termini e le Condizioni e l\'Informativa sulla Privacy',
      acceptTermsPart1: 'Accetto i',
      termsLink: 'Termini e le Condizioni',
      acceptTermsPart2: 'e l\'',
      privacyLink: 'Informativa sulla Privacy',
      termsRequired: 'Devi accettare i Termini e le Condizioni',
      submit: 'Crea account',
      loading: 'Creazione in corso...',
      success: 'Account creato con successo!',
      error: 'Errore durante la creazione dell\'account',
      fillRequired: 'Compila tutti i campi obbligatori',
      passwordMismatch: 'Le password non corrispondono',
      passwordLength: 'La password deve contenere almeno 6 caratteri',
    },
    resetPassword: {
      title: 'Reimposta password',
      subtitle: 'Inserisci il tuo indirizzo email per ricevere un link di reimpostazione',
      email: 'Email',
      submit: 'Invia il link',
      loading: 'Invio in corso...',
      success: 'Email di reimpostazione inviata!',
      error: 'Errore durante l\'invio dell\'email',
      backToLogin: 'Torna al login',
      enterEmail: 'Inserisci il tuo indirizzo email',
    },
    newPassword: {
      title: 'Nuova password',
      subtitle: 'Scegli una nuova password sicura per il tuo account',
      password: 'Nuova password',
      confirmPassword: 'Conferma password',
      placeholder: '••••••••',
      submit: 'Aggiorna password',
      loading: 'Aggiornamento...',
      success: 'Password aggiornata con successo',
      error: 'Errore durante l\'aggiornamento della password',
      mismatch: 'Le password non corrispondono',
      tooShort: 'La password deve contenere almeno 8 caratteri',
      invalidToken: 'Questo link di reimpostazione non è valido o è scaduto. Richiedine uno nuovo.',
      invalidTokenTitle: 'Link non valido',
      backToLogin: 'Torna al login',
    },
  },

  // Dashboard
  dashboard: {
    header: {
      shipper: 'Dashboard Speditore',
      transporter: 'Dashboard Vettore',
      driver: 'I miei Carichi',
      admin: 'Pannello di Amministrazione',
    },
    stats: {
      totalOrders: 'Totale ordini',
      activeOrders: 'Ordini attivi',
      activeOrdersLabel: 'In corso',
      draftOrders: 'Bozze',
      deliveredOrders: 'Consegnati',
      pendingBids: 'Offerte in attesa',
      completedOrders: 'Ordini completati',
      totalRevenue: 'Ricavi totali',
      activeDrivers: 'Autisti attivi',
      availableDrivers: 'Autisti disponibili',
      availableVehicles: 'Veicoli disponibili',
      ongoingMissions: 'Carichi in corso',
      activeMissions: 'Carichi attivi',
      completedMissions: 'Carichi completati',
      assignedMissions: 'Assegnati',
      totalTransporters: 'Totale vettori',
      totalDrivers: 'Totale autisti',
      totalCommands: 'Totale ordini',
      unpaidPayments: 'Pagamenti in sospeso',
    },
    emptyState: {
      noOrders: 'Nessun ordine al momento',
      noOrdersInProgress: 'Nessun ordine in corso',
      noActiveMissions: 'Nessun carico attivo',
      noMissions: 'Nessun carico al momento',
      noAssignedMissions: 'Nessun carico assegnato',
      noCompletedMissions: 'Nessun carico completato',
      noBids: 'Nessuna offerta al momento',
      noInProgress: 'Nessun ordine in corso',
      viewAllOrders: 'Visualizza tutti i miei ordini',
    },
    pendingReservations: {
      title: 'Prenotazioni in attesa di conferma',
      subtitle: '{{count}} vettore(i) ha prenotato i tuoi ordini',
      subtitles: ' ha',
      subtitlep: ' hanno',
    },
    ordersInProgress: {
      title: 'Ordini in corso',
      subtitle: 'I tuoi ordini assegnati e in transito',
    },
    activeMissions: {
      title: 'Carichi attivi',
      noMissions: 'Nessun carico attivo',
      consultMarketplace: 'Consulta il marketplace per prenotare carichi',
    },
    createOrder: 'Crea ordine',
  },

  // Orders
  orders: {
    title: 'I miei Ordini',
    noCoordinates: 'Coordinate mancanti',
    print: {
      title: 'Modulo d\'ordine',
      button: 'Scarica',
      printButton: 'Stampa',
      generating: 'Generazione in corso...',
      printing: 'Stampa in corso...',
      success: 'Immagine generata',
      downloaded: 'Modulo d\'ordine scaricato con successo',
      error: 'Errore',
      elementNotFound: 'Impossibile trovare il contenuto da catturare',
      generationFailed: 'Impossibile generare l\'immagine',
      qrNotGenerated: 'Codice QR non generato',
      pickupInfo: '📦 Informazioni sul ritiro',
      deliveryInfo: '🚚 Informazioni sulla consegna',
      cargoInfo: '📋 Merce',
      additionalInstructions: '⚠️ Istruzioni aggiuntive',
      notSpecified: 'Non specificato',
      title_field: 'Titolo:',
      vehicleType: 'Tipo di veicolo:',
      volume: 'Volume:',
      platformDescription: 'VELOX - Piattaforma di Gestione Logistica',
      generatedOn: 'Documento generato il',
    },
    subtitle: 'Gestisci tutti i tuoi ordini per stato',
    create: 'Crea ordine',
    createNew: '+ Crea ordine',
    filterByStatus: 'Filtra per stato',
    filterDescription: 'Seleziona uno stato per visualizzare gli ordini corrispondenti',
    selectStatus: 'Seleziona stato',
    orderNumber: 'Numero ordine',
    statuses: {
      all: 'Tutti',
      draft: 'Bozza',
      posted: 'Pubblicato',
      booked: 'Prenotato',
      assigned: 'Assegnato',
      in_transit: 'In transito',
      delivered: 'Consegnato',
      cancelled: 'Annullato',
      drafts: 'Bozze',
      posted_plural: 'Pubblicati',
      booked_plural: 'Prenotati',
      assigned_plural: 'Assegnati',
      in_transit_plural: 'In transito',
      delivered_plural: 'Consegnati',
      cancelled_plural: 'Annullati',
    },
    statusDescriptions: {
      draft: 'Ordine in creazione',
      posted: 'Ordine pubblicato sul marketplace',
      booked: 'Richiesta accettata, in attesa di assegnazione autista/veicolo',
      assigned: 'Autista e veicolo assegnati',
      in_transit: 'Ordine in transito',
      delivered: 'Ordine consegnato con successo',
      cancelled: 'Ordine annullato',
    },
    status: {
      draft: 'Bozza',
      posted: 'Pubblicato',
      booked: 'Prenotato',
      assigned: 'Assegnato',
      inTransit: 'In transito',
      delivered: 'Consegnato',
      cancelled: 'Annullato',
    },
    statusLabels: {
      pending: 'In attesa di conferma',
      accepted: 'Accettato',
      assigned: 'Assegnato',
    },
    emptyStates: {
      all: 'Nessun ordine al momento',
      draft: 'Nessuna bozza',
      posted: 'Nessun ordine pubblicato',
      booked: 'Nessun ordine prenotato',
      assigned: 'Nessun ordine assegnato',
      in_transit: 'Nessun ordine in transito',
      delivered: 'Nessun ordine consegnato',
      cancelled: 'Nessun ordine annullato',
    },
    priceValidated: 'Prezzo confermato',
    priceProposed: 'Prezzo proposto',
    myOffers: 'Le mie offerte',
    reservationPending: 'Prenotazione in attesa',
    confirmation: 'Conferma',
    refusal: 'Rifiuto',
    yourPreviousOfferDeclined: 'La tua offerta precedente è stata rifiutata',
    declinedOn: 'Rifiutato il',
    yourPendingOffer: 'La tua offerta in attesa',
    proposedAmount: 'Importo proposto',
    submittedOn: 'Inviato il',
    bookFixedPrice: 'Prenota al prezzo fisso',
    makeOffer: 'Fai un’offerta',
    makeNewOffer: 'Fai una nuova offerta',
    offerPendingResponse: 'Offerta in attesa di risposta',
    cancel: 'Annulla',
    confirmCancel: 'Sei sicuro di voler annullare la missione {{orderNumber}}?',
    cancelSuccess: 'Missione annullata con successo',
    cancelError: 'Errore durante l\'annullamento della missione',
    transporter: 'Vettore',
    statusLabel: 'Stato',
    pickupDate: 'Data di ritiro',
    pickupLocation: 'Luogo di ritiro',
    deliveryDate: 'Data di consegna',
    deliveryLocation: 'Luogo di consegna',
    weight: 'Peso',
    price: 'Prezzo',
    trailerType: 'Tipo di rimorchio',
    form: {
      title: 'Crea ordine',
      subtitle: 'Compila le informazioni del tuo trasporto',
      priceRequired: 'Prezzo proposto richiesto per pubblicare l’ordine',
    },
    card: {
      order: 'Ordine',
      validatedPrice: 'Prezzo confermato',
      proposedPrice: 'Prezzo proposto',
      weight: 'Peso',
      pallets: 'pallet',
      boxes: 'scatole',
      euroPallets: 'euro-pallet',
      publish: 'Pubblica',
      myOffers: 'Le mie offerte',
      track: 'Traccia',
      details: 'Dettagli',
    },
    details: {
      title: 'Dettagli completi dell’ordine',
      proposedPrice: 'Prezzo proposto',
      cargo: 'Merce',
      cargoTitle: 'Titolo:',
      cargoDescription: 'Descrizione:',
      cargoImage: 'Foto della merce',
      startImages: 'Foto di ritiro',
      deliveryImages: 'Foto di consegna',
      weight: 'Peso:',
      pallets: 'Pallet:',
      boxes: 'Scatole:',
      euroPallets: 'Euro-pallet:',
      volume: 'Volume:',
      type: 'Tipo:',
      route: 'Itinerario',
      pickup: 'Ritiro:',
      delivery: 'Consegna:',
      transporterInfo: 'Informazioni del vettore',
      company: 'Azienda',
      assignedDriver: 'Autista assegnato',
      vehicle: 'Veicolo',
      plateNumber: 'Targa',
      licenseNumber: 'Patente',
      trailerType: 'Tipo di rimorchio',
      specialInstructions: 'Istruzioni speciali',
      visibleMarketplace: '✓ Visibile sul marketplace',
      edit: 'Modifica',
      print: 'Stampa',
      delete: 'Elimina',
      close: 'Chiudi',
      confirmDelete: 'Conferma eliminazione',
      confirmDeleteText:
        'Sei sicuro di voler eliminare l’ordine {{orderNumber}}? Questa azione non può essere annullata.',
      cancel: 'Annulla',
      deleteSuccess: 'Ordine eliminato con successo',
      deleteError: 'Errore durante l’eliminazione dell’ordine',
    },
    messages: {
      publishedSuccess: 'Ordine pubblicato con successo!',
      publishError: 'Errore durante la pubblicazione dell’ordine',
    },
  },

  // Bids
  bids: {
    title: 'Offerte',
    offersReceived: 'Offerte ricevute',
    offersReceivedCount: 'Offerte ricevute ({{count}})',
    viewBids: 'Visualizza offerte',
    noBids: 'Nessuna offerta al momento',
    noBidsReceived: 'Nessuna offerta ricevuta al momento',
    newBid: 'Nuova offerta',
    amount: 'Importo',
    proposedAmount: 'Importo proposto',
    message: 'Messaggio',
    submit: 'Invia offerta',
    accept: 'Accetta',
    decline: 'Rifiuta',
    accepted: 'Accettata',
    declined: 'Rifiutata',
    pending: 'In attesa',
    receivedOn: 'Ricevuta il',
    orderDetails: 'Dettagli dell’ordine',
    acceptBid: 'Accetta',
    declineBid: 'Rifiuta',
  },

  // Marketplace
  marketplace: {
    title: 'Marketplace',
    subtitle: 'Trova ordini disponibili',
    filters: 'Filtri',
    trailerType: 'Tipo di rimorchio',
    allTypes: 'Tutti i tipi',
    departureCity: 'Città di partenza',
    departureCityPlaceholder: 'Es: Roma',
    arrivalCity: 'Città di arrivo',
    arrivalCityPlaceholder: 'Es: Milano',
    availabilityDate: 'Data di disponibilità',
    selectDate: 'Seleziona una data',
    sortByDistance: 'Ordina per distanza',
    noSort: 'Nessun ordinamento',
    sortAsc: 'Più vicino prima',
    sortDesc: 'Più lontano prima',
    resetFilters: 'Ripristina filtri',
    searchOrders: 'Cerca ordini...',
    sortBy: 'Ordina per',
    sortNewest: 'Più recenti',
    sortPrice: 'Prezzo',
    sortDistance: 'Distanza',
    noOrders: 'Nessun ordine disponibile',
    loadMore: 'Carica altri',
    pickupLocation: 'Luogo di ritiro',
    deliveryLocation: 'Luogo di consegna',
    weight: 'Peso',
    vehicleType: 'Tipo di veicolo',
    price: 'Prezzo',
    messages: {
      applicationSent: 'La tua candidatura è stata inviata con successo',
    },
    errors: {
      applicationError: 'Errore durante l\'invio della candidatura',
    },
    card: {
      pickup: 'Ritiro',
      delivery: 'Consegna',
      weight: 'Peso:',
      pallets: 'Pallet:',
      declinedBid: 'La tua offerta precedente è stata rifiutata',
      declinedAmount: 'Importo:',
      declinedOn: 'Rifiutata il',
      pendingBid: 'La tua offerta in attesa',
      proposedAmount: 'Importo proposto',
      message: 'Messaggio',
      submittedOn: 'Inviata il',
      bookFixed: 'Prenota a prezzo fisso',
      bidPending: 'Offerta in attesa di risposta',
      makeNewBid: 'Fai una nuova offerta',
      makeBid: 'Fai un’offerta',
    },
    placeBid: 'Fai un’offerta',
    viewDetails: 'Visualizza dettagli',
    bookOrder: 'Prenota ordine',
    bookingSuccess: 'Missione prenotata con successo',
    bookingError: 'Errore durante la prenotazione della missione',
  },

  // Fleet
  fleet: {
    title: 'Gestione della flotta',
    subtitle: 'Gestisci i tuoi veicoli e autisti',
    vehicles: 'Veicoli',
    drivers: 'Autisti',
    wizard: {
      step1: 'Passo 1: Tipo di veicolo',
      step2: 'Passo 2: Foto della carta di circolazione',
      step3: 'Passo 3: Informazioni del veicolo',
      step1Description: 'Seleziona il tipo di veicolo',
      step2Description: 'Carica foto (opzionale)',
      step3Description: 'Completa le informazioni',
    },
    extraction: {
      analyzing: 'Analisi in corso...',
      analyzingFront: 'Analisi del fronte in corso...',
      analyzingBack: 'Analisi del retro in corso...',
      success: 'Dati estratti con successo',
      frontComplete: 'Fronte analizzato',
      backComplete: 'Retro analizzato',
      successDesc: 'Le informazioni del veicolo sono state compilate automaticamente',
      error: 'Errore di estrazione',
      errorDesc: 'Impossibile estrarre i dati. Si prega di compilare manualmente.',
      step1: 'Passo 1/2: Fronte',
      step2: 'Passo 2/2: Retro',
      optional: 'Foto opzionali:',
      optionalDesc: 'Puoi scattare foto della carta di circolazione per compilare automaticamente i campi, o inserire le informazioni manualmente.',
      notRegistrationCard: 'Documento non riconosciuto',
      notRegistrationCardDesc: 'Questa immagine non sembra una carta di circolazione. Scatta una foto chiara di una carta valida.',
    },
    dialogs: {
      addVehicle: 'Aggiungi veicolo',
      editVehicle: 'Modifica veicolo',
      captureRegistration: 'Fotografa Libretto di Circolazione',
      captureRegistrationFront: 'Libretto di Circolazione - Fronte',
      captureRegistrationBack: 'Libretto di Circolazione - Retro',
      inviteDriver: 'Invita autista',
      editDriver: 'Modifica autista',
      vehicleType: 'Tipo di veicolo',
      plateNumber: 'Targa',
      plateNumberPlaceholder: 'Es: AB-123-CD',
      vin: 'Numero telaio (VIN)',
      vinPlaceholder: 'Es: 1HGBH41JXMN109186',
      brand: 'Marca',
      brandPlaceholder: 'Es: Fiat',
      model: 'Modello',
      modelPlaceholder: 'Es: Ducato',
      year: 'Anno',
      yearPlaceholder: 'Es: 2020',
      lastMaintenance: 'Ultima manutenzione',
      lastMaintenancePlaceholder: 'Seleziona una data',
      nextMaintenance: 'Prossima manutenzione',
      nextMaintenancePlaceholder: 'Seleziona una data',
      status: 'Stato',
      email: 'Email',
      firstName: 'Nome',
      lastName: 'Cognome',
      phone: 'Telefono',
      licenseNumber: 'Numero di patente',
      licenseExpiry: 'Scadenza patente',
      select: 'Seleziona',
      selectType: 'Seleziona tipo',
      selectVehicleType: 'Seleziona un tipo',
      required: '*',
      cancel: 'Annulla',
      add: 'Aggiungi',
      addingVehicle: 'Aggiunta veicolo...',
      save: 'Salva',
      sendInvitation: 'Invia invito',
      statusAvailable: 'Disponibile',
      statusOnMission: 'In missione',
      statusOffDuty: 'Fuori servizio',
    },
    invitations: 'Inviti',
    myVehicles: 'I miei veicoli',
    myDrivers: 'I miei autisti',
    addVehicle: 'Aggiungi veicolo',
    addDriver: '+ Invita autista',
    inviteDriver: 'Invita autista',
    addFirstVehicle: 'Aggiungi il tuo primo veicolo',
    inviteFirstDriver: 'Invita il tuo primo autista',
    noVehicles: 'Nessun veicolo registrato',
    noDrivers: 'Nessun autista registrato',
    noInvitations: 'Nessun invito',
    pendingInvitations: 'Inviti in attesa',
    activeDrivers: 'Autisti attivi',
    vehicleDetails: {
      brand: 'Marca',
      model: 'Modello',
      year: 'Anno',
      plateNumber: 'Targa',
      type: 'Tipo',
      status: 'Stato',
      available: 'Disponibile',
      unavailable: 'Non disponibile',
      inUse: 'In uso',
      onMission: 'In missione',
      maintenance: 'Manutenzione',
      lastMaintenance: 'Ultima manutenzione',
      nextMaintenance: 'Prossima manutenzione',
      vin: 'VIN:',
      modelLabel: 'Modello:',
      nextMaintenanceLabel: 'Prossima manutenzione:',
    },
    driverDetails: {
      name: 'Nome',
      email: 'Email',
      phone: 'Telefono',
      license: 'Patente',
      licenseNumber: 'Numero di patente',
      licenseExpiry: 'Scadenza patente',
      status: 'Stato',
      available: 'Disponibile',
      onMission: 'In missione',
      offDuty: 'Fuori servizio',
      unavailable: 'Non disponibile',
      noName: 'Autista senza nome',
      licenseExpiresOn: 'Patente scade il',
      position: 'Posizione',
      positionUnavailable: 'Posizione non disponibile',
      addedOn: 'Aggiunto il',
    },
    invitationDetails: {
      email: 'Email',
      phone: 'Telefono',
      pending: 'In attesa',
      expired: 'Scaduto',
      expires: 'Scade',
      sentOn: 'Invito inviato il',
    },
    cancelInvitation: 'Annulla invito',
    cancelInvitationTitle: 'Annulla invito',
    cancelInvitationDescription: 'Sei sicuro di voler annullare l\'invito di {{name}} ({{email}})? Questa azione è irreversibile.',
    confirmCancel: 'Sì, annulla',
    invitationDeleted: 'Invito annullato',
    invitationDeletedDescription: 'L\'invito è stato eliminato con successo',
    invitationDeleteError: 'Impossibile eliminare l\'invito',
    resendEmail: 'Reinvia email',
    emailResent: 'Email reinviata',
    emailResentDescription: 'L\'email di invito è stata reinviata a {{email}}',
    actions: {
      edit: 'Modifica',
      delete: 'Elimina',
      cancel: 'Annulla',
    },
    deleteDialog: {
      vehicleTitle: 'Elimina veicolo',
      vehicleDescription: 'Sei sicuro di voler eliminare il veicolo',
      driverTitle: 'Elimina autista',
      driverDescription: 'Sei sicuro di voler eliminare',
      irreversible: 'Questa azione non può essere annullata.',
    },
    documentStatus: {
      verified: 'Verificato',
      unverified: 'Non verificato',
      expired: 'Scaduto',
      expiringSoon: 'In scadenza',
      registrationCard: 'Libretto di circolazione',
      driverLicense: 'Patente di guida',
      scanRegistration: 'Scansiona libretto',
      scanLicense: 'Scansiona patente',
      rescan: 'Riscansiona',
      lockedField: 'Bloccato (verificato OCR)',
    },
    license: {
      title: 'Verifica patente',
      howTo: 'Come fare:',
      howToDesc: 'Scatta una foto del fronte e del retro della patente. I dati saranno estratti e bloccati automaticamente.',
      front: 'Fronte patente',
      back: 'Retro patente',
      captureFront: 'Scatta fronte',
      captureBack: 'Scatta retro',
      frontDone: 'Fronte analizzato',
      backDone: 'Retro analizzato',
      extracted: 'Dati estratti',
      extractedData: 'Dati patente',
      lockedNotice: 'Questi campi saranno bloccati e non modificabili manualmente.',
      categories: 'Categorie',
      save: 'Salva patente',
      saved: 'Patente salvata',
      savedDesc: 'La patente è stata verificata e salvata.',
      incomplete: 'Dati incompleti',
      incompleteDesc: 'Numero e data di scadenza sono obbligatori.',
      notALicense: 'Documento non riconosciuto',
      notALicenseDesc: 'Questa immagine non sembra una patente di guida. Scatta una foto chiara di una patente valida.',
    },
  },

  // Missions
  missions: {
    title: 'I miei Carichi',
    myMissions: 'I miei Carichi',
    subtitle: 'Gestisci i tuoi carichi di trasporto',
    all: 'Tutte',
    pending: 'In attesa',
    upcoming: 'Prossime',
    ongoing: 'In corso',
    active: 'Attive',
    completed: 'Terminate',
    assigned: 'Assegnate',
    search: 'Cerca per numero, città o indirizzo...',
    noResults: 'Nessun carico corrisponde alla tua ricerca',
    resultFound: 'risultato trovato',
    resultsFound: 'risultati trovati',
    noMissions: 'Nessun carico',
    noMissionPending: 'Nessun carico in attesa',
    noMissionActive: 'Nessun carico attivo',
    noMissionCompleted: 'Nessun carico completato',
    filters: {
      title: 'Filtri',
      trailerType: 'Tipo di rimorchio',
      distance: 'Distanza',
      allTrailers: 'Tutti i tipi',
      allDistances: 'Tutte le distanze',
      distance0to100: 'Meno di 100 km',
      distance100to500: '100 - 500 km',
      distance500to1000: '500 - 1000 km',
      distance1000plus: 'Più di 1000 km',
      clearFilters: 'Cancella filtri',
    },
    assignDriver: 'Assegna autista',
    assignVehicle: 'Assegna veicolo',
    startMission: 'Avvia missione',
    completeMission: 'Completa missione',
    orderNumber: 'Numero ordine',
    pickup: 'Ritiro',
    delivery: 'Consegna',
    status: 'Stato',
    accept: 'Accetta',
    decline: 'Rifiuta',
    scanQR: 'Scansiona QR',
    openDocuments: 'Documenti',
    uploadPOD: 'Carica POD',
    reportDelay: 'Segnala ritardo',
    actions: {
      assign: 'Assegna',
      viewDetails: 'Visualizza dettagli',
      accept: 'Accetta',
      decline: 'Rifiuta',
      refuse: 'Rifiuta',
      scanQR: 'Scansiona QR',
      documents: 'Documenti',
      viewDocuments: 'Visualizza documenti',
      reportDelay: 'Segnala ritardo',
      route: 'Itinerario',
    },
    history: 'Storico',
    inProgress: 'In corso',
    card: {
      orderNumber: 'Ordine n°',
      from: 'Da',
      to: 'A',
      order: 'Ordine',
      weight: 'Peso',
      type: 'Tipo',
      price: 'Prezzo',
      driver: 'Autista:',
      vehicle: 'Veicolo:',
      assign: 'Assegna',
      pickup: 'Ritiro',
      delivery: 'Consegna',
      cargo: 'Merce',
      notAssigned: 'Non assegnato',
      assignDriver: 'Assegna autista',
      delayReported: 'Ritardo segnalato',
      status: {
        completed: 'Terminata',
        inProgress: 'In corso',
        assigned: 'Assegnata',
        pending: 'In attesa',
      },
    },
    empty: {
      assigned: 'Nessun carico assegnato',
      active: 'Nessun carico attivo',
      completed: 'Nessun carico completato',
    },
  },

  // Billing
  billing: {
    title: 'Fatturazione',
    detailsTitle: 'Dettagli',
    subtitle: 'Gestisci i tuoi ordini di acquisto e fatture',
    filterByStatus: 'Filtra per stato',
    allStatuses: 'Tutti gli stati',
    documentType: 'Tipo di documento',
    documentNumber: 'Numero',
    amount: 'Importo IVA esclusa',
    vatRate: 'Aliquota IVA',
    vatAmount: 'Importo IVA',
    totalAmount: 'Totale IVA inclusa',
    issueDate: 'Data di emissione',
    dueDate: 'Data di scadenza',
    paidDate: 'Data di pagamento',
    types: {
      order_form: 'Ordine di acquisto',
      invoice: 'Fattura',
    },
    stats: {
      title: 'Panoramica',
      totalInvoiced: 'Totale fatturato',
      totalPaid: 'Totale pagato',
      totalPending: 'In attesa',
      paymentProgress: 'Progresso pagamenti',
    },
    statuses: {
      draft: 'Bozza',
      sent: 'Inviato',
      paid: 'Pagato',
      cancelled: 'Annullato',
    },
    tabs: {
      orderForms: 'Ordini d’acquisto',
      invoices: 'Fatture',
    },
    emptyStates: {
      orderForms: {
        title: 'Nessun ordine d’acquisto',
        description: 'Gli ordini verranno visualizzati qui una volta generati.',
      },
      invoices: {
        title: 'Nessuna fattura',
        description: 'Le fatture verranno visualizzate qui una volta generate.',
      },
    },
    messages: {
      pdfSuccess: 'PDF scaricato con successo',
      pdfError: 'Errore durante la generazione del PDF',
      markedAsPaid: 'Documento segnato come pagato',
      titleRequired: 'Il titolo non può essere vuoto',
      titleUpdated: 'Titolo aggiornato con successo',
    },
    status: {
      paid: 'Pagato',
      sent: 'Inviato',
      cancelled: 'Annullato',
      draft: 'Bozza',
    },
    documentTypes: {
      orderForm: 'Ordine d’acquisto',
      invoice: 'Fattura',
    },
    card: {
      order: 'Ordine:',
      route: 'Itinerario:',
      amountHT: 'Importo (escl. IVA)',
      vat: 'IVA',
      totalTTC: 'Totale (incl. IVA)',
      issuedOn: 'Emesso il:',
      dueDate: 'Scadenza:',
      paidOn: 'Pagato il:',
      view: 'Visualizza',
      pdf: 'PDF',
    },
    dialog: {
      documentNumber: 'Numero documento',
      customTitle: 'Titolo personalizzato',
      noTitle: 'Nessun titolo',
      titlePlaceholder: 'Inserisci un titolo per questo documento',
      shipper: 'Speditore',
      transporter: 'Vettore',
      orderDetails: 'Dettagli ordine',
      orderNumber: 'Numero ordine:',
      cargo: 'Merce:',
      route: 'Itinerario:',
      financialDetails: 'Dettagli finanziari',
      amountHT: 'Importo (escl. IVA)',
      vat: 'IVA',
      totalTTC: 'Totale (incl. IVA)',
      importantDates: 'Date importanti',
      issueDate: 'Data emissione',
      dueDate: 'Data scadenza',
      paymentDate: 'Data pagamento',
      notes: 'Note',
      markAsPaid: 'Segna come pagato',
      downloadPDF: 'Scarica PDF',
    },
    orderForms: 'Ordini d’acquisto',
    invoices: 'Fatture',
    noDocuments: 'Nessun documento',
    type: 'Tipo',
    date: 'Data',
    paid: 'Pagato',
    unpaid: 'Non pagato',
    overdue: 'Scaduto',
    markAsPaid: 'Segna come pagato',
    viewDocument: 'Visualizza documento',
    downloadPDF: 'Scarica PDF',
    details: {
      shipper: 'Speditore',
      transporter: 'Vettore',
      orderDetails: 'Dettagli ordine',
      route: 'Itinerario',
      cargo: 'Merce',
      financial: 'Riepilogo finanziario',
      subtotal: 'Subtotale',
      vat: 'IVA',
      total: 'Totale (incl. IVA)',
      createdAt: 'Creato il',
      dueDate: 'Scadenza',
      paidAt: 'Pagato il',
    },
  },

  // Notifications
  notifications: {
    title: 'Notifiche',
    markAllRead: 'Segna tutte come lette',
    markAll: 'Segna tutto',
    noNotifications: 'Nessuna notifica',
    empty: 'Nessuna notifica',
    markAsReadError: 'Errore durante la marcatura della notifica',
    markAllAsReadError: 'Errore durante la marcatura di tutte le notifiche',
    allMarkedAsRead: 'Tutte le notifiche contrassegnate come lette',
    notificationNotFound: 'Impossibile trovare questo ordine',
    types: {
      mission_assigned: 'Missione assegnata',
      new_bid: 'Nuova offerta',
      bid_accepted: 'Offerta accettata',
      bid_declined: 'Offerta rifiutata',
      order_updated: 'Ordine aggiornato',
      mission_started: 'Carico avviato',
      mission_completed: 'Carico completato',
      payment_received: 'Pagamento ricevuto',
      rating_reminder: 'Promemoria di valutazione',
    },
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    marketplace: 'Marketplace',
    missions: 'Carichi',
    liveMap: 'Mappa Live',
    myMissions: 'I miei Carichi',
    myOrders: 'I miei Ordini',
    fleet: 'Flotta',
    billing: 'Fatturazione',
    settings: 'Impostazioni',
    logout: 'Disconnetti',
  },

  // Tracking
  liveMap: {
    description: 'Traccia tutti i tuoi carichi attivi in tempo reale',
    noActiveMissions: 'Nessun carico attivo al momento',
    filters: 'Filtri',
    searchPlaceholder: 'Cerca per numero d\'ordine...',
    noResults: 'Nessun carico corrisponde ai filtri',
    dateFilter: 'Periodo',
    allOrders: 'Tutti gli ordini',
    today: 'Oggi',
    last7Days: 'Ultimi 7 giorni',
    last30Days: 'Ultimi 30 giorni',
    last90Days: 'Ultimi 90 giorni',
    last365Days: 'Ultimi 365 giorni',
  },

  tracking: {
    title: 'Tracciamento ordine',
    orderNotFound: 'Ordine non trovato',
    returnToDashboard: 'Torna alla dashboard',
    deliveryDocuments: 'Documenti di consegna',
    trackingHistory: 'Storico tracciamento',
    trackingMap: 'Mappa tracciamento',
    noEvents: 'Nessun evento di tracciamento per ora',
    interactiveMap: 'Mappa interattiva',
    noCoordinates: 'Coordinate GPS non disponibili per questo ordine',
    events: {
      pickup_confirmed: 'Ritiro confermato',
      in_transit: 'In transito',
      delivered: 'Consegnato',
      exception: 'Eccezione',
    },
  },

  // Settings
  settings: {
    companyDocuments: {
      title: 'Documenti aggiunti da Velox',
      description: 'Documenti associati alla tua azienda dal team Velox.',
      empty: 'Nessun documento aggiunto per ora.',
    },
    title: 'Impostazioni',
    subtitle: 'Gestisci le tue informazioni personali e dell\'account',
    tabs: {
      profile: 'Profilo',
      company: 'Azienda',
      language: 'Lingua',
      email: 'Email',
      password: 'Password',
      notifications: 'Notifiche',
    },
    profile: {
      title: 'Informazioni personali',
      description: 'Aggiorna i tuoi dati personali',
      firstName: 'Nome',
      lastName: 'Cognome',
      phone: 'Telefono',
      save: 'Salva modifiche',
      companyLogo: 'Logo aziendale',
      profilePhoto: 'Foto profilo',
      changeImage: 'Cambia immagine',
      imageHint: 'JPG, PNG o WebP. Max 2 MB.',
      imageUploadSuccess: 'Immagine aggiornata con successo',
      imageUploadError: 'Errore durante il caricamento dell\'immagine',
      imageTypeError: 'Formato non supportato. Usa JPG, PNG o WebP.',
      imageSizeError: 'Il file è troppo grande. Massimo 2 MB.',
    },
    company: {
      title: 'Informazioni aziendali',
      description: 'Gestisci i dati della tua azienda',
      name: 'Nome dell\'azienda',
      registrationNumber: 'Numero identificazione fiscale',
      registrationNumberDescription: 'SIRET, P.IVA o identificatore fiscale secondo il tuo paese',
      iban: 'IBAN (facoltativo)',
      ibanPlaceholder: 'IT60 X054 2811 1010 0000 0123 456',
      ibanDescription: 'Utilizzato per pagamenti e fatturazione. Puoi aggiungerlo in seguito.',
      ibanInvalid: 'IBAN non valido',
      address: 'Indirizzo',
      phone: 'Telefono',
      save: 'Salva modifiche',
    },
    language: {
      title: 'Lingua dell\'interfaccia',
      description: 'Scegli la tua lingua preferita',
      label: 'Lingua',
      note: 'La lingua verrà applicata a tutta l\'interfaccia',
    },
    email: {
      title: 'Indirizzo email',
      description: 'Modifica il tuo indirizzo email di accesso',
      newEmail: 'Nuovo indirizzo email',
      update: 'Aggiorna email',
      notifications: {
        label: 'Notifiche via email',
        description: 'Ricevi notifiche importanti via email',
      },
    },
    password: {
      title: 'Password',
      description: 'Cambia la tua password di accesso',
      currentPassword: 'Password attuale',
      newPassword: 'Nuova password',
      confirmPassword: 'Conferma password',
      save: 'Cambia password',
    },
    notifications: {
      title: 'Notifiche',
      description: 'Gestisci le tue preferenze di notifica',
      emailLabel: 'Notifiche via email',
      emailDescription: 'Ricevi notifiche via email',
    },
    validation: {
      firstNameRequired: 'Il nome è obbligatorio',
      lastNameRequired: 'Il cognome è obbligatorio',
      companyNameRequired: 'Il nome dell\'azienda è obbligatorio',
      maxLength: 'Massimo {{max}} caratteri',
      emailInvalid: 'Email non valida',
      passwordMin: 'Minimo 6 caratteri',
      passwordMismatch: 'Le password non corrispondono',
    },
    messages: {
      profileUpdated: 'Profilo aggiornato con successo',
      profileError: 'Errore nell\'aggiornamento del profilo',
      companyUpdated: 'Azienda aggiornata con successo',
      companyError: 'Errore nell\'aggiornamento dell\'azienda',
      emailSent: 'Email di conferma inviata',
      emailError: 'Errore nell\'aggiornamento dell\'email',
      currentPasswordIncorrect: 'La password attuale non è corretta',
      passwordUpdated: 'Password aggiornata con successo',
      passwordError: 'Errore nell\'aggiornamento della password',
      languageUpdated: 'Lingua aggiornata con successo',
      languageError: 'Errore nell\'aggiornamento della lingua',
      emailPreferencesUpdated: 'Preferenze di notifica aggiornate',
      notificationsUpdated: 'Preferenze di notifica aggiornate',
      notificationsError: 'Errore nell\'aggiornamento delle notifiche',
    },
  },

  // Admin
  admin: {
    title: 'Pannello di Amministrazione',
    unpaidPayments: 'Pagamenti in sospeso',
    auditLogs: 'Registri di audit',
    allPaid: 'Tutti i pagamenti sono aggiornati',
    noPendingOrders: 'Nessun pagamento in sospeso',
    transporter: 'Vettore',
    orders: 'Ordini',
    totalAmount: 'Importo totale',
    action: 'Azione',
    markPaid: 'Segna come pagato',
    confirmPayment: 'Conferma pagamento',
    confirmPaymentText:
      'Sei sicuro di voler segnare come pagati i {{count}} ordine/i di {{name}} per un importo totale di {{amount}} €?',
    recording: 'Registrazione in corso...',
    cancel: 'Annulla',
    filters: 'Filtri',
    reset: 'Ripristina',
    table: 'Tabella',
    allTables: 'Tutte le tabelle',
    allActions: 'Tutte le azioni',
    dateFrom: 'Data inizio',
    dateTo: 'Data fine',
    noAuditLogs: 'Nessun registro di audit trovato',
    tryModifyFilters: 'Prova a modificare i filtri',
    logsWillAppear: 'I registri di audit appariranno qui',
    timestamp: 'Timestamp',
    user: 'Utente',
    details: 'Dettagli',
    system: 'Sistema',
    oldValues: 'Valori precedenti',
    newValues: 'Valori nuovi',
    clickToSee: 'Clicca per vedere',
    
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      users: 'Utenti e Aziende',
      orders: 'Ordini',
      invoices: 'Fatture',
      stats: 'Statistiche',
    },
    
    // Dashboard
    dashboard: {
      title: 'Dashboard Admin',
      subtitle: 'Panoramica della piattaforma',
      filters: {
        day: 'Oggi',
        week: 'Questa settimana',
        month: 'Questo mese',
      },
      revenue: 'Ricavi',
      ordersDelivered: 'Ordini consegnati',
      ordersPosted: 'Ordini pubblicati',
      ordersInProgress: 'In corso',
      vsLastPeriod: 'vs. periodo precedente',
      vsAverage: 'vs. media',
      revenueChart: 'Evoluzione dei ricavi',
      ordersChart: 'Evoluzione degli ordini',
    },
    
    // Users & Companies
    users: {
      title: 'Utenti e Aziende',
      subtitle: 'Gestione utenti e aziende',
      name: 'Nome',
      email: 'Email',
      company: 'Azienda',
      role: 'Ruolo',
      status: 'Stato',
      registrationDate: 'Data di registrazione',
      actions: 'Azioni',
      suspend: 'Sospendi',
      delete: 'Elimina',
      promoteAdmin: 'Promuovi admin',
      viewDetails: 'Vedi dettagli',
      filters: {
        role: 'Filtra per ruolo',
        status: 'Filtra per stato',
        company: 'Filtra per azienda',
        date: 'Filtra per data',
        allRoles: 'Tutti i ruoli',
        allStatuses: 'Tutti gli stati',
        allCompanies: 'Tutte le aziende',
      },
      statuses: {
        active: 'Attivo',
        suspended: 'Sospeso',
        deleted: 'Eliminato',
      },
      showDeleted: 'Mostra account eliminati',
      deletedHiddenCount: '{{count}} account eliminato/i nascosto/i',
      userDetails: {
        title: 'Dettagli utente',
        personalInfo: 'Informazioni personali',
        companyInfo: 'Informazioni azienda',
        phone: 'Telefono',
        language: 'Lingua preferita',
        emailNotifications: 'Notifiche email',
        enabled: 'Abilitate',
        disabled: 'Disabilitate',
      },
      companyDetails: {
        createdAt: 'Creata il',
        companyCreatedSince: 'Dal {{date}}',
        title: 'Dettagli azienda',
        type: 'Tipo',
        siret: 'SIRET',
        address: 'Indirizzo',
        users: 'Utenti associati',
        fleet: 'Flotta',
        drivers: 'Autisti',
        documents: 'Documenti',
        vehicleCount: 'Veicoli',
        driverCount: 'Autisti',
        documentStatus: 'Stato documenti',
        valid: 'Validi',
        expired: 'Scaduti',
        missing: 'Mancanti',
      },
      confirmSuspend: 'Conferma sospensione',
      confirmSuspendMessage: 'Sei sicuro di voler sospendere questo utente?',
      confirmDelete: 'Eliminare definitivamente questo account',
      confirmDeleteMessage: 'L’account sarà anonimizzato: i dati personali vengono cancellati e l’accesso è bloccato definitivamente. Lo storico degli ordini viene conservato. Questa azione è irreversibile.',
      deleteSuccess: 'Account eliminato e anonimizzato',
      deleteError: 'Errore durante l’eliminazione dell’account',
      confirmPromote: 'Conferma promozione',
      confirmPromoteMessage: 'Sei sicuro di voler promuovere questo utente ad amministratore?',
      userSuspended: 'Utente sospeso',
      userDeleted: 'Utente eliminato',
      userPromoted: 'Utente promosso ad amministratore',
      error: 'Si è verificato un errore',
    },
    
    // Orders
    adminOrders: {
      title: 'Ordini',
      subtitle: 'Gestione ordini',
      orderId: 'ID Ordine',
      shipper: 'Mittente',
      transporter: 'Trasportatore',
      amount: 'Importo',
      status: 'Stato',
      date: 'Data',
      actions: 'Azioni',
      viewDetails: 'Vedi dettagli',
      markDelivered: 'Segna come consegnato',
      cancelOrder: 'Annulla',
      viewInvoice: 'Vedi fattura',
      filters: {
        status: 'Filtra per stato',
        date: 'Filtra per data',
        shipper: 'Filtra per mittente',
        transporter: 'Filtra per trasportatore',
        allStatuses: 'Tutti gli stati',
      },
      orderDetails: {
        title: 'Dettagli ordine',
        route: 'Percorso',
        cargo: 'Carico',
        pricing: 'Prezzo',
        documents: 'Documenti',
        tracking: 'Tracciamento',
      },
      confirmMarkDelivered: 'Conferma consegna',
      confirmMarkDeliveredMessage: 'Sei sicuro di voler segnare questo ordine come consegnato?',
      confirmCancel: 'Conferma annullamento',
      confirmCancelMessage: 'Sei sicuro di voler annullare questo ordine?',
      orderMarkedDelivered: 'Ordine segnato come consegnato',
      orderCancelled: 'Ordine annullato',
      error: 'Si è verificato un errore',
    },
    
    // Invoices
    invoices: {
      title: 'Fatture',
      subtitle: 'Gestione fatture',
      invoiceId: 'ID Fattura',
      shipper: 'Mittente',
      transporter: 'Trasportatore',
      amount: 'Importo',
      status: 'Stato',
      date: 'Data',
      actions: 'Azioni',
      markPaidAction: 'Segna come pagata',
      report: 'Segnala',
      viewDetails: 'Vedi dettagli',
      statuses: {
        pending: 'In sospeso',
        paid: 'Pagata',
        reported: 'Segnalata',
        cancelled: 'Annullata',
      },
      invoiceDetails: {
        title: 'Dettagli fattura',
        shipperInfo: 'Informazioni mittente',
        transporterInfo: 'Informazioni trasportatore',
        orderInfo: 'Informazioni ordine',
        history: 'Cronologia',
        comments: 'Commenti admin',
        addComment: 'Aggiungi commento',
      },
      confirmMarkPaid: 'Conferma pagamento',
      confirmMarkPaidMessage: 'Sei sicuro di voler segnare questa fattura come pagata?',
      confirmReport: 'Segnala fattura',
      confirmReportMessage: 'Sei sicuro di voler segnalare questa fattura?',
      confirmCancel: 'Annulla fattura',
      confirmCancelMessage: 'Sei sicuro di voler annullare questa fattura? Questa azione è irreversibile.',
      reportReason: 'Motivo della segnalazione',
      invoiceMarkedPaid: 'Fattura segnata come pagata',
      invoiceReported: 'Fattura segnalata',
      commentAdded: 'Commento aggiunto',
      error: 'Si è verificato un errore',
    },
  },

  // Vehicle Types (Trailer Types)
  vehicleTypes: {
    van: 'Mega Trailer / High Cube',
    flatbed: 'Cassonato / Pianale',
    refrigerated: 'Rimorchio Frigo (Refrigerato / Isotermico)',
    tanker: 'Cisterna Liquidi',
    curtainsider: 'Rimorchio Centinato / Telonato',
    lowloader: 'Ribaltabile (Kipper)',
    container: 'Portacontainer',
    any: 'Qualsiasi tipo',
    car: 'Rimorchio Porta Auto',
    van_small: 'Furgone Piccolo',
    utility: 'Walking Floor (Pavimento mobile)',
    other: 'Rimorchio Aperto per Trasporto Eccezionale',
  },

  // Shipper
  shipper: {
    dashboard: {
      title: 'Dashboard Speditore',
      createOrder: 'Crea ordine',
      pendingReservations: 'Prenotazioni in attesa di conferma',
      pendingReservationsSubtitle:
        '{{count}} vettore/i hanno prenotato i tuoi ordini',
      pendingBids: 'Offerte Ricevute',
      pendingBidsSubtitle: 'Hai {{count}} offerta/e in attesa di validazione',
      ordersInProgress: 'Ordini in corso',
      ordersInProgressSubtitle: 'I tuoi ordini assegnati e in transito',
      viewAllOrders: 'Visualizza tutti i miei ordini',
      noOrdersInProgress: 'Non ci sono ordini in corso al momento',
    },
    stats: {
      totalOrders: 'Totale ordini',
      inProgress: 'In corso',
      delivered: 'Consegnati',
      drafts: 'Bozze',
    },
    reservation: {
      pending: 'Prenotazione in attesa',
      transporter: 'Vettore',
      confirming: 'Conferma in corso...',
      confirm: 'Conferma',
      declining: 'Rifiuto in corso...',
      decline: 'Rifiuta',
    },
    bids: {
      order: 'Ordine',
      pickup: 'Ritiro',
      delivery: 'Consegna',
      transporter: 'Trasportatore',
      proposedAmount: 'Importo Proposto',
      message: 'Messaggio',
      submittedOn: 'Inviato il',
    },
    messages: {
      reservationConfirmed: 'Prenotazione confermata con successo',
      reservationDeclined: 'Prenotazione rifiutata',
      bidAccepted: 'Offerta accettata con successo',
      bidDeclined: 'Offerta rifiutata',
    },
    errors: {
      confirmError: 'Errore durante la conferma',
      declineError: 'Errore durante il rifiuto',
      acceptBidError: "Errore nell'accettazione dell'offerta",
      declineBidError: "Errore nel rifiuto dell'offerta",
    },
  },

  // Transporter
  transporter: {
    dashboard: {
      title: 'Dashboard Vettore',
      activeMissions: 'Carichi attivi',
      noActiveMissions: 'Nessun carico attivo',
      checkMarketplace: 'Visita il marketplace per prenotare carichi',
      cancelMissionConfirm:
        'Sei sicuro di voler annullare il carico {{orderNumber}}?',
    },
    stats: {
      availableVehicles: 'Veicoli disponibili',
      activeMissions: 'Carichi in corso',
      availableDrivers: 'Autisti disponibili',
      completedMissions: 'Carichi completati',
    },
    mission: {
      pendingConfirmation: 'In attesa di conferma',
      assigned: 'Assegnata',
      accepted: 'Accettata',
      pickup: 'Ritiro',
      delivery: 'Consegna',
      driver: 'Autista:',
      vehicle: 'Veicolo:',
    },
    messages: {
      missionCanceled: 'Missione annullata con successo',
    },
  },

  // Landing
  landing: {
    hero: {
      title: 'Velox',
      titleHighlight: 'gestisci i tuoi carichi di trasporto,',
      titleEnd: 'senza sforzo',
      subtitle:
        'Una Progressive Web App ottimizzata per desktop e mobile: pubblica merci, accedi al marketplace, assegna autisti, convalida tramite codice QR e gestisci i pagamenti — tutto in un unico posto.',
      tryFree: 'Prova gratuitamente',
      learnMore: 'Scopri di più',
      cta: 'Iscriviti',
    },
    allYouNeed: {
      title: 'Tutto ciò di cui hai bisogno',
      subtitle: 'Una piattaforma completa per gestire in modo efficiente la tua attività di trasporto',
    },
    features: {
      title: 'Funzionalità principali',
      shipments: {
        title: 'Gestione spedizioni',
        description: 'Crea, traccia e gestisci i tuoi ordini di trasporto in tempo reale con un\'interfaccia intuitiva.',
      },
      fleet: {
        title: 'Gestione flotta',
        description: 'Ottimizza l\'utilizzo dei tuoi veicoli e autisti con strumenti di pianificazione avanzati.',
      },
      tracking: {
        title: 'Tracciamento in tempo reale',
        description: 'Localizza le tue consegne in diretta e tieni i tuoi clienti informati ad ogni passo.',
      },
      multiUser: {
        title: 'Multi-utente',
        description: 'Collabora efficacemente con il tuo team grazie a ruoli e permessi personalizzati.',
      },
      planning: {
        title: 'Pianificazione intelligente',
        description: 'Ottimizza i tuoi percorsi e pianifica i tuoi carichi con algoritmi intelligenti.',
      },
      security: {
        title: 'Massima sicurezza',
        description: 'I tuoi dati sono protetti con i più alti standard di sicurezza.',
      },
    },
    workflow: {
      title: 'Flusso di lavoro principale',
      subtitle: 'V1 - marketplace completo e flusso del processo',
      steps: {
        step1: {
          badge: 'Passo 1',
          title: 'Pubblicazione carico (Mittente)',
          description: 'Creazione account aziendale, configurazione ordine (tipo di rimorchio, destinazione, finestra di consegna, prezzo proposto). L\'ordine appare nel marketplace.',
        },
        step2: {
          badge: 'Passo 2',
          title: 'Selezione e prenotazione (Vettore)',
          description: 'Registrazione vettore e onboarding autisti. Marketplace con filtri (percorso, tipo di carico, distanza). Prenota e conferma il carico.',
        },
        step3: {
          badge: 'Passo 3',
          title: 'Assegnazione autista',
          description: 'Link automatico inviato per la creazione dell\'account autista collegato all\'azienda. L\'autista accetta la missione tramite la PWA.',
        },
        step4: {
          badge: 'Passo 4',
          title: 'Carico e partenza',
          description: 'L\'autista effettua il check-in al sito di carico. Convalida tramite codice QR o conferma manuale → lo stato passa a "in transito".',
        },
        step5: {
          badge: 'Passo 5',
          title: 'Consegna',
          description: 'Convalida tramite codice QR o pulsante "Consegnato". Carica foto e documenti POD/CMR. Le notifiche vengono inviate istantaneamente, stato aggiornato sul dashboard.',
        },
        step6: {
          badge: 'Passo 6',
          title: 'Pagamento e chiusura',
          description: 'L\'amministratore convalida gli ordini consegnati per i pagamenti giornalieri. La fattura viene generata automaticamente. Il mittente riceve la fattura e valuta il vettore.',
        },
      },
    },
    comparison: {
      title: "Trova la soluzione che fa per te",
      subtitle: "Che tu sia uno spedizioniere o un trasportatore, Velox semplifica la gestione delle tue operazioni di trasporto",
      shipper: {
        title: "Spedizionieri",
        benefits: [
          "Pubblica i tuoi ordini di trasporto in pochi clic",
          "Accedi a una rete di trasportatori verificati",
          "Traccia le tue consegne in tempo reale",
          "Gestisci le tue fatture e pagamenti facilmente",
          "Beneficia di un servizio clienti dedicato"
        ],
        cta: "Inizia come spedizioniere"
      },
      transporter: {
        title: "Trasportatori",
        benefits: [
          "Accedi a migliaia di offerte di trasporto",
          "Ottimizza l'utilizzo della tua flotta",
          "Gestisci i tuoi autisti e veicoli semplicemente",
          "Ricevi i tuoi pagamenti rapidamente",
          "Fai crescere la tua attività in modo efficiente"
        ],
        cta: "Inizia come trasportatore"
      }
    },
    faq: {
      title: 'Domande Frequenti',
      subtitle: 'Tutto quello che devi sapere su Velox',
      questions: {
        whatIsVelox: {
          question: 'Cos\'è Velox?',
          answer: 'Velox è una Progressive Web App progettata per semplificare la gestione dei carichi di trasporto tra spedizionieri, vettori e autisti. Centralizza la pubblicazione del carico, la prenotazione, l\'assegnazione, la convalida della consegna e il monitoraggio dei pagamenti.',
        },
        needDownload: {
          question: 'Devo scaricare un\'app?',
          answer: 'No. Velox è una PWA — funziona direttamente su browser desktop e mobile. Non è richiesta alcuna installazione da App Store o Google Play.',
        },
        whoCanUse: {
          question: 'Chi può usare Velox?',
          answer: 'Velox supporta tre tipi principali di utenti: Spedizionieri (pubblicare ordini di carico e tracciare le consegne), Vettori (esplorare e prenotare carichi, assegnare carichi agli autisti) e Autisti (ricevere carichi, convalidare passaggi, caricare documenti di consegna).',
        },
        driverJoin: {
          question: 'Come si uniscono gli autisti alla piattaforma?',
          answer: 'Gli autisti ricevono un link automatico dal loro vettore. Creano un account autista connesso in pochi passaggi.',
        },
        deliveryValidation: {
          question: 'Come viene convalidata la consegna?',
          answer: 'La consegna può essere convalidata scansionando un codice QR o tramite un pulsante di conferma manuale. Gli autisti possono anche caricare direttamente documenti POD/CMR e foto.',
        },
        notifications: {
          question: 'Che tipo di notifiche vengono inviate?',
          answer: 'Velox invia notifiche email a spedizionieri, vettori e autisti per eventi chiave: prenotazioni, assegnazioni di carichi, aggiornamenti di stato e conferme di consegna.',
        },
        multilingual: {
          question: 'Velox è multilingue e multi-valuta?',
          answer: 'Sì. La PWA supporta più lingue e valute per adattarsi a diversi mercati.',
        },
        payment: {
          question: 'Come funziona il pagamento?',
          answer: 'Una volta che una consegna è contrassegnata come completata, l\'Amministratore Velox la convalida per il pagamento giornaliero. Una fattura viene generata automaticamente e inviata allo spedizioniere.',
        },
        history: {
          question: 'Posso vedere i miei carichi o spedizioni passate?',
          answer: 'Assolutamente. Velox include una cronologia completa per ogni ruolo: Spedizioniere (consegne, costi, KPI), Vettore (spedizioni, valutazioni, preferenze) e Autista (carichi + tutti i documenti correlati).',
        },
        production: {
          question: 'Velox è un\'app di produzione?',
          answer: 'Questa versione è un prototipo (V1) incentrato sul flusso di lavoro principale e sulle capacità del marketplace. Più funzionalità saranno aggiunte nelle prossime iterazioni.',
        },
      },
    },
    ctaSection: {
      title: 'Pronto a trasformare la tua logistica?',
      subtitle: 'Unisciti alle aziende che ottimizzano il loro trasporto con Velox',
      createAccount: 'Crea un account gratuito',
    },
    cta: {
      title: 'Pronto per iniziare?',
      subtitle: 'Unisciti a noi oggi',
    },
    footer: {
      copyright: '© 2025 Velox. Tutti i diritti riservati.',
    },
  },

  // Not Found
  notFound: {
    message: 'Ops! Pagina non trovata',
    backToHome: 'Torna all\'home page',
  },

  // Create Order
  createOrder: {
    title: 'Crea un ordine',
    subtitle: 'Compila le informazioni del tuo trasporto',
    
    section1: {
      title: '1. Itinerario',
      description: 'Informazioni su ritiro e consegna',
      pickup: 'Ritiro',
      delivery: 'Consegna',
    },
    
    address: {
      streetNumber: 'Numero',
      streetName: 'Nome via',
      postalCode: 'CAP',
      city: 'Città',
      country: 'Paese',
      streetNumberPlaceholder: '123',
      streetNamePlaceholder: 'Via della Repubblica',
      postalCodePlaceholder: '75000',
      cityPlaceholder: 'Parigi',
      countryPlaceholder: 'Francia',
    },
    
    dateTime: {
      pickupDate: 'Data di ritiro',
      pickupTime: 'Ora di ritiro',
      deliveryDate: 'Data di consegna',
      deliveryTime: 'Ora di consegna',
      chooseDate: 'Scegli una data',
    },
    
    contact: {
      label: 'Contatto',
      phone: 'Telefono',
      contactPlaceholder: 'Mario Rossi',
      phonePlaceholder: '6 12 34 56 78',
    },
    
    access: {
      detailsLabel: "Dettagli d'accesso (opzionale)",
      detailsPlaceholder: 'Es: Codice cancello 1234, Ingresso dal parcheggio posteriore, Suonare ufficio 3...',
      detailsHelper: "Specifica i dettagli per accedere al luogo di ritiro",
      deliveryDetailsPlaceholder: 'Es: Citofono 2° piano, Consegna lato strada, Accesso parcheggio visitatori...',
      deliveryDetailsHelper: "Specifica i dettagli per accedere al luogo di consegna",
      photosLabel: "Foto d'accesso (opzionale)",
      photosHelper: "Massimo 5 immagini per aiutare a trovare il luogo di ritiro",
      deliveryPhotosHelper: "Massimo 5 immagini per aiutare a trovare il luogo di consegna",
      maxImagesError: 'Massimo 5 immagini consentite',
    },
    
    gps: {
      calculating: 'Calcolo posizione GPS...',
      calculated: 'Posizione GPS calcolata',
    },
    
    section2: {
      title: '2. Merce',
      subtitle: 'Dettagli del carico da trasportare',
      cargoTitle: 'Titolo della merce',
      cargoTitlePlaceholder: 'Es: Pallet di prodotti elettronici, Mobili per ufficio...',
      vehicleType: 'Tipo di veicolo',
      vehicleTypePlaceholder: 'Seleziona un tipo',
      anyVehicle: 'Qualsiasi tipo di veicolo',
      weight: 'Peso (kg)',
      weightPlaceholder: '1000',
      volume: 'Volume (m³)',
      volumePlaceholder: '10.5',
      unitType: 'Tipo di unità',
      unitTypePlaceholder: 'Seleziona un tipo',
      quantity: 'Quantità',
      quantityPlaceholder: 'Es: 12',
      cargoDescription: 'Descrizione della merce',
      cargoDescriptionPlaceholder: 'Descrivi la natura del tuo carico...',
      specialInstructions: 'Istruzioni speciali',
      specialInstructionsPlaceholder: 'Requisiti specifici, vincoli orari...',
      cargoPhoto: 'Foto della merce (opzionale)',
      cargoPhotoHelper: "Un'immagine per illustrare la tua merce",
    },
    
    unitTypes: {
      palettes: 'Pallet',
      caisses: 'Casse',
      euroPalettes: 'Euro-pallet',
    },
    
    section3: {
      title: '3. Tariffazione',
      subtitle: 'Metodo di fissazione del prezzo',
      pricingMode: 'Modalità di tariffazione',
      fixedPrice: 'Prezzo fisso',
      fixedPriceDesc: 'Tu stabilisci il prezzo di trasporto',
      auction: 'Asta',
      auctionDesc: 'I trasportatori propongono le loro tariffe',
      proposedPrice: 'Prezzo proposto (€)',
      proposedPricePlaceholder: '850.00',
    },
    
    section4: {
      title: '4. Visibilità',
      subtitle: "Pubblicazione dell'ordine",
      marketplaceVisible: 'Rendi visibile sul marketplace',
      marketplaceVisibleDesc: 'I trasportatori potranno vedere e inviare offerte',
    },
    
    actions: {
      saveDraft: 'Salva bozza',
      createOrder: 'Crea ordine',
      creating: 'Creazione...',
    },
    
    toasts: {
      draftSaved: 'Bozza salvata!',
      orderCreated: 'Ordine creato e pubblicato!',
      priceRequired: "Prezzo proposto richiesto per pubblicare l'ordine",
      error: "Errore durante la creazione dell'ordine",
    },
    
    validation: {
      numberTooLong: 'Numero troppo lungo',
      streetNameRequired: 'Nome via richiesto (min. 3 caratteri)',
      streetNameTooLong: 'Nome via troppo lungo',
      postalCodeRequired: 'CAP richiesto',
      postalCodeTooLong: 'CAP troppo lungo',
      cityRequired: 'Città richiesta',
      cityTooLong: 'Città troppo lunga',
      countryRequired: 'Paese richiesto',
      countryTooLong: 'Paese troppo lungo',
      pickupDateRequired: 'Data di ritiro richiesta',
      deliveryDateRequired: 'Data di consegna richiesta',
      invalidTime: 'Orario non valido (formato HH:MM)',
      contactRequired: 'Nome contatto richiesto',
      contactTooLong: 'Nome troppo lungo',
      phoneRequired: 'Telefono richiesto (min. 8 cifre)',
      phoneTooLong: 'Telefono troppo lungo',
      detailsTooLong: 'Dettagli troppo lunghi',
      cargoTitleRequired: 'Titolo richiesto (min. 3 caratteri)',
      cargoTitleTooLong: 'Titolo troppo lungo',
      vehicleTypeRequired: 'Tipo di veicolo richiesto',
      weightRequired: 'Peso richiesto',
      weightMax: 'Peso massimo 100.000 kg',
      volumeMax: 'Volume massimo 200 m³',
      quantityNegative: 'La quantità non può essere negativa',
      quantityMax: 'Massimo 100',
      descriptionRequired: 'Descrizione richiesta (min. 10 caratteri)',
      descriptionTooLong: 'Descrizione troppo lunga',
      instructionsTooLong: 'Istruzioni troppo lunghe',
      priceRequired: 'Prezzo richiesto',
      priceMax: 'Prezzo massimo 1.000.000€',
    },
  },

  // Rating System
  rating: {
    title: 'Valuta questa consegna',
    question: 'Com\'è andata questa consegna?',
    comment: 'Commento (facoltativo)',
    commentPlaceholder: 'Condividi la tua esperienza con questo partner...',
    submit: 'Invia la mia valutazione',
    submitting: 'Invio in corso...',
    success: 'Grazie per la tua valutazione!',
    error: 'Errore nell\'invio della valutazione',
    alreadyRated: 'Hai già valutato questo ordine',
    rateDelivery: 'Valuta consegna',
    rateClient: 'Valuta questo cliente',
    toRate: 'Da valutare',
    noRatingsYet: 'Nessuna valutazione ancora',
    
    excellent: 'Eccellente! 🌟',
    veryGood: 'Molto bene 👍',
    good: 'Bene ✓',
    fair: 'Discreto',
    poor: 'Insufficiente',
    
    companyProfile: {
      title: 'Valutazioni',
      average: 'Valutazione media',
      totalReviews: 'recensioni',
      distribution: 'Distribuzione valutazioni',
    },
    
    yourRating: 'La tua valutazione',
    partnerRating: 'Valutazione del partner',
  },

  // Toast
  toast: {
    reservationConfirmed: 'Prenotazione confermata con successo',
    reservationDeclined: 'Prenotazione rifiutata',
    error: 'Si è verificato un errore',
  },

  // Legal
  legal: {
    termsOfService: {
      title: "Termini e Condizioni",
      lastUpdate: "Ultimo aggiornamento",
      section1: {
        title: "1. Scopo",
        content: "Questi Termini e Condizioni definiscono le modalità d'uso della piattaforma Velox, un servizio di connessione tra speditori e vettori. Utilizzando la nostra piattaforma, accetti incondizionatamente questi Termini e Condizioni.",
      },
      section2: {
        title: "2. Registrazione e Account Utente",
        content: "L'uso della piattaforma richiede la creazione di un account utente. Ti impegni a fornire informazioni accurate e aggiornate, incluso il tuo numero di P.IVA e i tuoi dati bancari (IBAN). Sei responsabile della riservatezza delle tue credenziali di accesso.",
      },
      section3: {
        title: "3. Servizi Offerti",
        content: "Velox collega speditori che necessitano di servizi di trasporto con vettori professionali. La piattaforma facilita la creazione di ordini, l'invio di offerte, il monitoraggio in tempo reale e la gestione della fatturazione. Velox agisce esclusivamente come intermediario e non è parte del contratto di trasporto.",
      },
      section4: {
        title: "4. Obblighi degli Utenti",
        content: "Gli speditori si impegnano a fornire informazioni accurate sulle loro merci. I vettori si impegnano a possedere le licenze e le assicurazioni necessarie per esercitare la loro attività. Tutti gli utenti si impegnano a rispettare la legislazione vigente e a non utilizzare la piattaforma per scopi fraudolenti.",
      },
      section5: {
        title: "5. Tariffe e Pagamento",
        content: "I prezzi sono liberamente negoziati tra speditori e vettori. Velox applica una commissione su ogni transazione effettuata tramite la piattaforma. I pagamenti sono sicuri e vengono elaborati attraverso il nostro sistema di pagamento integrato. Le fatture sono disponibili nella sezione fatturazione.",
      },
      section6: {
        title: "6. Responsabilità",
        content: "Velox non può essere ritenuto responsabile per danni derivanti dall'esecuzione del contratto di trasporto tra speditore e vettore. La responsabilità di Velox è limitata alla fornitura della piattaforma. In caso di controversia, le parti si impegnano a cercare una soluzione amichevole prima di qualsiasi azione legale.",
      },
    },
    privacyPolicy: {
      title: "Informativa sulla Privacy",
      lastUpdate: "Ultimo aggiornamento",
      section1: {
        title: "1. Editore della Piattaforma",
        content: "Velox è pubblicato da [Nome azienda], società per azioni semplificata con capitale di [importo] euro, registrata presso il RCS di [città] con numero [numero], con sede legale in [indirizzo completo]. Direttore di pubblicazione: [Nome]. Contatto: contact@velox.com",
      },
      section2: {
        title: "2. Hosting",
        content: "La piattaforma Velox è ospitata da Supabase Inc., 970 Toa Payoh North, #07-04, Singapore 318992. Il servizio utilizza un'infrastruttura cloud sicura con server situati in Europa (conforme al GDPR).",
      },
      section3: {
        title: "3. Protezione dei Dati Personali",
        content: "In conformità con il GDPR, hai il diritto di accedere, rettificare ed eliminare i tuoi dati personali. I dati raccolti (nome, email, telefono, P.IVA, IBAN) sono necessari per il funzionamento del servizio e vengono conservati in modo sicuro. Non vengono mai condivisi con terze parti senza il tuo consenso.",
      },
      section4: {
        title: "4. Cookie",
        content: "La piattaforma utilizza cookie tecnici essenziali per il funzionamento del servizio (autenticazione, preferenze di lingua). Non vengono utilizzati cookie pubblicitari o di tracciamento. Puoi configurare il tuo browser per rifiutare i cookie, ma ciò potrebbe influire su alcune funzionalità.",
      },
      section5: {
        title: "5. Proprietà Intellettuale",
        content: "Tutti gli elementi della piattaforma Velox (loghi, testi, grafica, software) sono protetti da copyright e sono di proprietà esclusiva di Velox. Qualsiasi riproduzione, rappresentazione o sfruttamento non autorizzato è vietato.",
      },
      section6: {
        title: "6. Legge Applicabile",
        content: "Queste note legali sono disciplinate dalla legge francese. In caso di controversia, i tribunali francesi avranno giurisdizione esclusiva. Per qualsiasi domanda relativa alle note legali, puoi contattarci all'indirizzo: legal@velox.com",
      },
    },
  },
  support: {
    title: 'Supporto Velox',
    description: 'Contatta il nostro team di supporto',
    callVelox: 'Chiama Velox',
    email: 'Email',
    phone: 'Telefono',
    adminTitle: 'Contatti supporto Velox',
    adminDescription: 'Questi dati vengono mostrati agli utenti quando contattano il supporto.',
  },
  supportChat: {
    title: 'Supporto Velox',
    adminTitle: 'Ticket di supporto',
    adminNav: 'Supporto',
    open: 'Apri chat',
    yourTickets: 'I tuoi ticket',
    newTicket: 'Nuovo ticket',
    empty: 'Nessun ticket per ora',
    writeMessage: 'Scrivi un messaggio…',
    send: 'Invia',
    skip: 'Salta questo passaggio',
    pickOrder: 'Seleziona il carico interessato:',
    descPlaceholder: 'Descrivi il tuo problema o la tua richiesta…',
    selectTicket: 'Seleziona un ticket per vedere la conversazione',
    markResolved: 'Segna come risolto',
    close: 'Chiudi',
    assignMe: 'Assegna a me',
    filter: { all: 'Tutti gli stati' },
    status: {
      bot: 'Qualificazione',
      pending_admin: 'In attesa',
      open: 'Aperto',
      resolved: 'Risolto',
      closed: 'Chiuso',
    },
    cat: {
      offer: 'Un\'offerta',
      mission: 'Un carico',
      account: 'Il mio account',
      payment: 'Pagamento / fatturazione',
      other: 'Altro',
    },
    bot: {
      greeting: 'Ciao 👋 Sono l\'assistente Velox. Ti indirizzerò alla persona giusta.',
      askCategory: 'Di cosa vuoi parlarci?',
      askContext: 'A quale carico si riferisce la tua richiesta? (puoi anche saltare questo passaggio)',
      askDescription: 'Descrivi la tua richiesta in poche parole, il team ti risponderà a breve.',
      handoff: 'Grazie! Un membro del team Velox prenderà in carico la richiesta e risponderà al più presto.',
    },
  },
  adminCreate: {
    navShort: 'Crea account',
    title: 'Crea un account',
    subtitle: 'Crea un\'azienda mittente, trasportatore, o aggiungi un autista a un\'azienda esistente.',
    tabs: {
      shipper: 'Azienda mittente',
      transporter: 'Azienda trasportatore',
      driver: 'Autista',
      admin: 'Amministratore',
    },
    sections: {
      company: 'Informazioni azienda',
      ownerInfo: 'Titolare dell\'account',
      driverInfo: 'Informazioni autista',
      adminInfo: "Informazioni dell'amministratore",
      attachToTransporter: 'Azienda trasportatore',
      activation: 'Attivazione account',
    },
    fields: {
      foundedDate: 'Data di fondazione',
      companyName: 'Nome azienda',
      companyPhone: 'Telefono azienda',
      transporter: 'Azienda trasportatore',
      transporterPlaceholder: 'Seleziona un\'azienda',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      password: 'Password temporanea',
      passwordPlaceholder: 'Almeno 8 caratteri',
      passwordHint: 'L\'utente potrà modificarla dopo il login.',
    },
    mode: {
      invite: {
        label: 'Invia un invito via email',
        desc: 'L\'utente riceve un link per impostare la password e attivare l\'account.',
      },
      direct: {
        label: 'Crea direttamente con una password',
        desc: 'L\'account è subito attivo. Comunica la password alla persona.',
      },
    },
    submit: {
      invite: 'Invia invito',
      direct: 'Crea account',
    },
    success: {
      invite: 'Invito inviato con successo.',
      direct: 'Account creato con successo.',
    },
    errors: {
      missingUser: 'Compila tutti i campi utente.',
      missingCompany: 'Compila nome e telefono azienda.',
      pickCompany: 'Seleziona un\'azienda trasportatore.',
      shortPassword: 'La password deve avere almeno 8 caratteri.',
      emailTaken: 'Questo indirizzo email appartiene già a un account esistente. Nessun account creato e nessuna email inviata.',
      generic: 'Errore durante la creazione dell\'account.',
    },
  },
  emailTemplates: {
    tab: 'Email',
    title: 'Modelli email',
    description: 'Personalizza le email inviate quando si creano account.',
    invitation: 'Invito (attivazione utente)',
    passwordReset: 'Reimpostazione password',
    signupWelcome: "Benvenuto (registrazione)",
    emailChange: "Cambio indirizzo e-mail",
    directWelcome: 'Benvenuto (creazione diretta)',
    subject: 'Oggetto',
    bodyHtml: 'Contenuto HTML',
    enabled: 'Email attivata',
    enabledHint: 'Se disabilitata, non sarà inviata alcuna email.',
    bccAdmin: "Copia nascosta (BCC) all'admin",
    bccAdminHint: 'Ricevere una copia nascosta di ogni email.',
    variables: 'Variabili disponibili',
  },
  adminDocuments: {
    docSearchPlaceholder: 'Cerca un documento (file, categoria, ordine, targa, autista)...',
    categoryAll: 'Tutte le categorie',
    statusAll: 'Tutti gli stati',
    resetFilters: 'Reimposta',
    noResults: 'Nessun documento corrisponde alla ricerca.',
    companiesShown_one: '{{count}} azienda visualizzata',
    companiesShown_other: '{{count}} aziende visualizzate',
    addedByVelox: 'Aggiunto da Velox',
    categories: {
      kyc: 'KYC / identità',
      insurance_license: 'Assicurazione e licenza',
      contract: 'Contratto / commerciale',
      registration_card: 'Libretto di circolazione',
      inspection: 'Revisione tecnica',
      driver_license: 'Patente di guida',
      loading_photos: 'Foto di carico',
      delivery_photos: 'Foto di consegna',
      cmr: 'CMR / bolla di consegna',
      other: 'Altro',
    },
    add: {
      button: 'Aggiungi un documento',
      buttonShort: 'Aggiungi',
      title: 'Aggiungi un documento',
      description: 'Questo documento sarà associato a {{company}} e visibile a tale azienda.',
      scope: 'Associa a',
      scopeCompany: "L'azienda (onboarding)",
      scopeOrder: 'Un ordine (carico)',
        scopeVehicle: 'Un veicolo',
        scopeDriver: 'Un autista',
        vehicle: 'Veicolo',
        vehicleSearch: 'Cerca un veicolo...',
        vehiclePlaceholder: 'Seleziona un veicolo',
        noVehicles: 'Questa azienda non ha ancora veicoli registrati.',
        noDrivers: 'Questa azienda non ha ancora autisti registrati.',
        vehicleRequired: 'Seleziona un veicolo.',
        driver: 'Autista',
        driverSearch: 'Cerca un autista...',
        driverPlaceholder: 'Seleziona un autista',
        driverRequired: 'Seleziona un autista.',
      order: 'Ordine',
      orderSearch: 'Cerca un ordine...',
      orderPlaceholder: 'Seleziona un ordine',
      category: 'Categoria',
      label: 'Etichetta',
      labelPlaceholder: 'Es. Attestato di assicurazione 2026',
      expiry: 'Data di scadenza (facoltativa)',
      notes: 'Nota interna (facoltativa)',
      chooseFile: 'Scegli un file',
      fileHint: 'Formati accettati: PDF, JPG, PNG (max 10 MB)',
      uploading: 'Caricamento in corso...',
      submit: 'Aggiungi il documento',
      success: 'Documento aggiunto',
      error: 'Non è stato possibile aggiungere il documento',
      invalidType: 'Formato non supportato. Usa PDF, JPG o PNG.',
      tooLarge: 'File troppo grande (max 10 MB)',
      fileRequired: 'Seleziona un file',
      orderRequired: 'Seleziona un ordine',
      deleteTitle: 'Eliminare questo documento?',
      deleteDescription: '{{name}} sarà eliminato definitivamente. Questa azione è irreversibile.',
      deleteSuccess: 'Documento eliminato',
      deleteError: 'Non è stato possibile eliminare il documento',
    },
    breadcrumb: 'Documenti',
    shippers: 'Mittenti',
    transporters: 'Trasportatori',
    title: 'Documenti utenti',
    subtitle: 'Seleziona un\'azienda per visualizzare i suoi documenti organizzati per categoria.',
    searchPlaceholder: 'Cerca un\'azienda...',
    noCompanies: 'Nessuna azienda {{side}}.',
    sideShipper: 'mittente',
    sideTransporter: 'trasportatore',
    usersCount_one: '{{count}} utente',
    usersCount_other: '{{count}} utenti',
    docsCount_one: '{{count}} doc',
    docsCount_other: '{{count}} doc',
    expiredCount_one: '{{count}} scaduto',
    expiredCount_other: '{{count}} scaduti',
    missingCount_one: '{{count}} mancante',
    missingCount_other: '{{count}} mancanti',
    complete: 'Completo',
    back: 'Indietro',
    sectionOnboarding: 'Onboarding',
    sectionFleet: 'Flotta',
    sectionFreight: 'Carichi',
    onboardingTitle: 'Documenti di onboarding',
    onboardingDesc: 'Visura, P.IVA, IBAN, licenza di trasporto, RC, condizioni generali…',
    onboardingEmpty: 'Nessun documento di onboarding caricato per questa azienda.',
    fleetTitle: 'Documenti della flotta',
    trucks: 'Camion',
    trailers: 'Rimorchi',
    drivers: 'Autisti',
    emptyTrucks: 'Nessun camion registrato.',
    emptyTrailers: 'Nessun rimorchio registrato.',
    emptyDrivers: 'Nessun autista registrato.',
    noDocsResource: 'Nessun documento associato.',
    freightTitle: 'Documenti dei carichi',
    freightDesc: 'Una voce per carico: ordine di trasporto, CMR / POD, dogana, contestazioni, foto.',
    freightEmpty: 'Nessun carico con documenti.',
    orderLabel: 'Carico {{number}}',
    noDocs: 'Nessun documento.',
    tableNature: 'Tipo',
    tableFile: 'File',
    tableStatus: 'Stato',
    tableSize: 'Dimensione',
    tableDate: 'Data',
    tableAction: 'Azione',
    statusVerified: 'Verificato',
    statusExpiring: 'In scadenza',
    statusExpired: 'Scaduto',
    statusUnverified: 'Non verificato',
    licensePrefix: 'Patente',
    licenseExpires: 'scade',
    licenseNotSet: 'Patente non indicata',
    openError: 'Impossibile aprire il documento',
    natureRegistration: 'Libretto',
    natureInsurance: 'Assicurazione',
    natureInspection: 'Revisione',
    natureOther: 'Altro',
    natureCargo: 'Foto carico',
    natureStart: 'Foto ritiro',
    natureDelivery: 'Foto consegna',
    natureDocument: 'Documento',
  },
  footer: {
    tagline: 'La piattaforma di trasporto e logistica che collega mittenti, trasportatori e autisti in tutta Europa.',
    legalTitle: 'Informazioni legali',
    contactTitle: 'Assistenza',
    partnersTitle: 'I nostri partner',
    copyright: '© 2026 Velox. Tutti i diritti riservati.',
    links: {
      about: 'Chi siamo',
      terms: 'Termini e condizioni',
      privacy: 'Informativa sulla privacy',
      legalNotice: 'Note legali',
      cookiePolicy: 'Informativa sui cookie',
      cookieSettings: 'Impostazioni cookie',
    },
    short: {
      about: 'Chi siamo',
      terms: 'Termini',
      privacy: 'Privacy',
      legalNotice: 'Note legali',
      cookies: 'Cookie',
      support: 'Assistenza',
    },
  },
  legalNotice: {
    back: 'Torna alla home',
    title: 'Note legali',
    lastUpdated: 'Ultimo aggiornamento: gennaio 2026',
    sections: {
      publisher: {
        title: 'Editore del sito',
        body: 'Velox\nPiattaforma di gestione del trasporto e della logistica.\nContatto: support@myvelox.eu\nSito: https://myvelox.eu',
      },
      hosting: {
        title: 'Hosting',
        body: 'Il sito e i suoi servizi sono ospitati da fornitori di infrastrutture cloud situati nell’Unione europea.',
      },
      intellectualProperty: {
        title: 'Proprietà intellettuale',
        body: 'Tutti i contenuti presenti sulla piattaforma (testi, immagini, loghi, codice) sono protetti dal diritto di proprietà intellettuale. È vietata qualsiasi riproduzione o riutilizzo senza previa autorizzazione scritta.',
      },
      dataProtection: {
        title: 'Protezione dei dati',
        body: 'I dati personali sono trattati in conformità al GDPR. Per maggiori informazioni consulta la nostra informativa sulla privacy. Puoi esercitare i diritti di accesso, rettifica e cancellazione contattando l’assistenza.',
      },
      contact: {
        title: 'Contatti',
        body: 'Per qualsiasi domanda relativa alle presenti note legali, contatta il nostro team di assistenza dall’app o via e-mail.',
      },
    },
  },
  cookies: {
    alwaysOn: 'Sempre attivi',
    banner: {
      title: 'Rispettiamo la tua privacy',
      description: 'Utilizziamo cookie strettamente necessari al funzionamento di Velox e, con il tuo consenso, cookie funzionali e analitici.',
      readPolicy: 'Leggi l\'informativa sui cookie',
      customize: 'Personalizza',
      acceptAll: 'Accetta tutto',
      rejectAll: 'Rifiuta tutto',
      save: 'Salva le mie scelte',
    },
    categories: {
      necessary: {
        title: 'Cookie strettamente necessari',
        description: 'Indispensabili al funzionamento del sito (sessione, sicurezza, memorizzazione delle scelte sui cookie).',
      },
      functional: {
        title: 'Cookie funzionali',
        description: 'Memorizzano le tue preferenze, come la lingua selezionata.',
      },
      analytics: {
        title: 'Cookie analitici',
        description: 'Ci aiutano a capire come viene utilizzato il sito (PostHog) per migliorarlo.',
      },
    },
  },
  invite: {
    title: 'Unisciti a Velox',
    subtitle: 'Sei stato invitato a unirti a',
    subtitleRole: 'come',
    email: 'Email',
    firstName: 'Nome',
    lastName: 'Cognome',
    password: 'Password',
    passwordPlaceholder: 'Almeno 8 caratteri',
    confirmPassword: 'Conferma password',
    confirmPasswordPlaceholder: 'Ripeti la password',
    creating: 'Creazione in corso...',
    createAccount: 'Crea il mio account',
    invalidTitle: 'Invito non valido',
    invalidDescription: 'Questo invito non è valido, è scaduto o è già stato utilizzato. Contatta chi ti ha invitato.',
    backToLogin: 'Torna al login',
    welcome: 'Benvenuto!',
    accountConfigured: 'Il tuo account è stato configurato.',
    accountReady: 'Account pronto',
    pleaseSignIn: 'Accedi con la tua nuova password.',
    sentInvitations: 'Inviti inviati',
    statusAccepted: 'Accettato',
    passwordSet: 'Password creata',
    emailAlreadyUsed: 'Questo indirizzo appartiene già a un account ({{company}} — {{role}}). Nessuna email inviata.',
    invitationAlreadyPending: 'Esiste già un invito in attesa per questo indirizzo ({{company}}). Nessuna email inviata.',
    errors: {
      expired: 'Questo invito è scaduto.',
      alreadyAccepted: 'Questo invito è già stato utilizzato.',
      invalidToken: 'Link di invito non valido.',
      weakPassword: 'La password deve contenere almeno 8 caratteri.',
      passwordMismatch: 'Le password non corrispondono.',
      generic: 'Impossibile completare la registrazione. Riprova o contatta il supporto.',
    },
  },
  adminInvitations: {
    actions: 'Azioni',
    resend: 'Rinvia l\'invito',
    resendSuccess: 'Invito rinviato',
    resendSuccessDescription: 'Una nuova email è stata inviata a {{email}}.',
    resendError: 'Non è stato possibile rinviare l\'invito.',
    delete: 'Elimina',
    deleteTitle: 'Eliminare questo invito?',
    deleteDescription: 'Il link di invito smetterà subito di funzionare. L\'azione è irreversibile.',
    deleteSuccess: 'Invito eliminato',
    deleteError: 'Non è stato possibile eliminare l\'invito.',
    searchPlaceholder: 'Cerca un invito...',
    refresh: 'Aggiorna',
    pageInfo: 'Pagina {{page}} / {{total}} — {{count}} invito/i',
    title: 'Inviti inviati',
    empty: 'Nessun invito al momento.',
    person: 'Persona',
    email: 'Email',
    company: 'Azienda',
    role: 'Ruolo',
    sentAt: 'Inviato il',
    expiresAt: 'Scade il',
    status: 'Stato',
    statuses: {
      pending: 'In attesa',
      accepted: 'Accettato',
      expired: 'Scaduto',
    },
  },
};
